import {
  ABORT_PROCESS,
  GET_AVAILABLE_PROCESSES,
  OCCUPANCY_LOADED,
  OCCUPANCY_UPDATED,
  PROCESS_UPDATE,
  REQUEST_ERROR,
  RESET, SET_REPORT_DATA,
  RESET_IF_ACTIVE_PROCESS_MATCHES,
  SET_SEEDTYPE,
  SET_SEEDTYPEID_FOR_PROCESSINFORMATION,
  SET_SELECTION,
  START_PROCESS,
  MODIFY_PROCESS,
  UPDATE_DISPLAY_PREFIX,
  UPDATE_DISPLAY_VALUE,
  UPDATE_WEIGHT,
  SET_TASK_DATA,
} from '../types/contextTypes';
export default (state, action) => {
  switch (action.type) {
    case UPDATE_WEIGHT:
      return {
        ...state,
        currentWeight: action.payload,
      };
    case GET_AVAILABLE_PROCESSES:
      return {
        ...state,
        processes: action.payload.result.data.processes,
        error: null,
      };
    case OCCUPANCY_LOADED:
      return {
        ...state,
        occupancyArray: action.payload,
      };
    case OCCUPANCY_UPDATED:
      return {
        ...state,
        occupancyArray: action.payload,
      };
    case REQUEST_ERROR:
      return {
        ...state,
        processError: action.payload,
      };
    case MODIFY_PROCESS: {
      return {
        ...state,        
      }
    }
    case START_PROCESS:
      return {
        ...state,
        activeProcessId: action.payload.id,
        activeProcessType: action.payload.type,
        processFinished: false,
        error: null,
        processStarted: true,
      };
    case PROCESS_UPDATE:
      return {
        ...state,
        //activeProcessType: action.payload.activeProcessType,
        additionalProcessInformation: action.payload.additionalProcessInformation,
        backIsAllowed: action.payload.backIsAllowed,
        requestedInformationType: action.payload.requestedInformationType,
        processInfoMessage: action.payload.processInfoMessage,
        processFinished: action.payload.processFinished,
        error: null,
        numPadDisplay: {
          ...state.numPadDisplay,
          prefix: null,
          value: '',
        },
      };
    case RESET:
      return action.payload;
    case RESET_IF_ACTIVE_PROCESS_MATCHES:
      if (state.activeProcessId !== action.payload.processId) {
        return state;
      }
      return action.payload.nextState;
    case ABORT_PROCESS:
      return {
        ...state,
        activeProcessId: null,
        processStarted: false,
        processFinished: false,
        additionalProcessInformation: null,
        processError: action.payload?.message || null 
      };
    case SET_REPORT_DATA:
      return {
        ...state,
        reportData: action.payload,
      };
    case SET_SELECTION:
      return {
        ...state,
        selection: action.payload,
      };
    case SET_SEEDTYPE:
      return {
        ...state,
        selectedSeedType: action.payload,
      };
    case SET_SEEDTYPEID_FOR_PROCESSINFORMATION:
      return {
        ...state,
        additionalProcessInformation: {
          ...state.additionalProcessInformation,
          seedTypeId: action.payload,
        },
      };
    case UPDATE_DISPLAY_PREFIX:
      return {
        ...state,
        numPadDisplay: {
          ...state.numPadDisplay,
          prefix: action.payload,
        },
      };
    case UPDATE_DISPLAY_VALUE:
      return {
        ...state,
        numPadDisplay: {
          ...state.numPadDisplay,
          value: action.payload,
        },
      };
    case SET_TASK_DATA:
    return {
      ...state,
      taskData: action.payload
    };
    default:
      return state;
  }
};
